export default __webpack_public_path__ + "static/media/beat2.10af8a51.mp3";